import React, { useState, useEffect } from 'react'
import queryString from 'query-string'
import {
  APIENDPOINT,
  getCWPEnvironmentForURL,
  sanitizeHTML,
} from '../../../../shared/utils/common-utils'
import axios from 'axios'

// a phone number formatter that supports 10 digit
// phone numbers, formatting them in accordance with Ameriprise
// practices (https://www.ameriprise.com/customer-service/contact)
const PhoneNumber = props => {
  let numericString = !isNaN(Number(props.phoneNumber))

  // eg 6121119999
  let tenDigit = props.phoneNumber.length === 10

  if (numericString && tenDigit) {
    // This will convert 6121119999 --> 612.111.9999
    let formattedValue = `${props.phoneNumber.slice(0, 3)}.${props.phoneNumber.slice(
      3,
      6
    )}.${props.phoneNumber.slice(6)}`
    return <span className='u-textColorLight'>{formattedValue}</span>
  } else {
    return <span className='u-textColorLight'>{props.phoneNumber}</span>
  }
}

const PresenterPreview = () => {
  const [advisorId, setAdvisorId] = useState('')
  const [advisorInformation, setAdvisorInformation] = useState({})
  useEffect(() => {
    let queryStrings = queryString.parse(window.location.search, {
      arrayFormat: 'bracket',
    })

    if (queryStrings.advisorId) {
      setAdvisorId(queryStrings.advisorId)
      localStorage.setItem('ameSTriprise-rig-advisorId', queryStrings.advisorId)
    } else if (localStorage.getItem('results')) {
      const storedResults = localStorage.getItem('results')
      setAdvisorInformation(JSON.parse(storedResults))
    }
  }, [])

  useEffect(() => {
    async function fetchData() {
      if (!advisorId) {
        return
      }
      const env = getCWPEnvironmentForURL(window.location.href)
      const advisorInfoUrl = `${APIENDPOINT(env).advisor}GetAdvisorById?advisorId=${advisorId}`
      try {
        const response = await axios.get(advisorInfoUrl)
        const results = response.data.result
        localStorage.setItem('results', JSON.stringify(results))
        setAdvisorInformation(results)
      } catch (error) {}
    }
    fetchData()
  }, [advisorId])

  return (
    <div className='u-size1of2 u-paddingVert3gu u-paddingHoriz6gu u-bgColorLight u-marginBottom3gu'>
      <div className='u-flex u-flexWrap u-marginBottom4gu'>
        {status === 'error' && (
          <div className='u-flex u-flexCol u-flexAlignItemsCenter'>
            <p className='u-textColorAlert'>
              The advisor does not exist or something is wrong with the advisorId.
            </p>
          </div>
        )}
        {status === 'fetching' && <div className='loading'></div>}
        {advisorInformation && (
          <>
            <div className='u-sizeFull u-textCenter'>
              {advisorInformation.profilesmallimage && (
                <img
                  alt={advisorInformation.displayname}
                  className='setup-preview-image'
                  src={sanitizeHTML(advisorInformation.profilesmallimage)}
                />
              )}
            </div>
            <div className='u-paddingTop7gu'>
              <p className='u-textColorBrand u-marginBottom2gu u-textSizeMsrp2'>
                {advisorInformation.displayname}
              </p>
              <p className='u-textColorLight u-marginBottom2gu'>
                {advisorInformation.phonenumber ? (
                  <PhoneNumber phoneNumber={advisorInformation.phonenumber} />
                ) : (
                  ''
                )}
                {advisorInformation.phonenumber && advisorInformation.email ? ' | ' : ''}
                {advisorInformation.email ? advisorInformation.email : ''}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default PresenterPreview
